import { Stack, TextField, Typography } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { ContactBlockContent } from '@/types/database';

export function ContactBlockEditPanel({
  content,
  onUpdate,
}: {
  content: ContactBlockContent;
  onUpdate: (content: ContactBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content || {}, onUpdate);

  return (
    <Stack spacing={1.5}>
      <TextField
        label="Heading"
        value={draft.heading || ''}
        onChange={(event) => update({ ...draft, heading: event.target.value })}
        fullWidth
      />
      <TextField
        label="Description"
        value={draft.description || ''}
        onChange={(event) => update({ ...draft, description: event.target.value })}
        fullWidth
      />
      <Typography variant="caption" color="text.secondary">
        The contact form collects name, email, and message from visitors.
      </Typography>
    </Stack>
  );
}
